const VOID_HTML_TAGS = new Set([
  'area',
  'base',
  'br',
  'col',
  'embed',
  'hr',
  'img',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr',
])

export const isValidBalancedHtml = (value = '') => {
  const tags = value.match(/<\/?([a-zA-Z][\w:-]*)(\s[^<>]*)?\s*\/?>/g) || []
  const stack = []
  let cursor = 0

  for (const tag of tags) {
    const index = value.indexOf(tag, cursor)
    if (index < 0) {
      return false
    }
    const between = value.slice(cursor, index)
    if (between.includes('<') || between.includes('>')) {
      return false
    }

    const closeMatch = tag.match(/^<\/([a-zA-Z][\w:-]*)\s*>$/)
    if (closeMatch) {
      const [, tagName] = closeMatch
      if (stack.pop() !== tagName.toLowerCase()) {
        return false
      }
      cursor = index + tag.length
      continue
    }

    const openMatch = tag.match(/^<([a-zA-Z][\w:-]*)(\s[^<>]*)?\s*\/?>$/)
    if (!openMatch) {
      return false
    }
    const [, rawTagName] = openMatch
    const tagName = rawTagName.toLowerCase()
    const selfClosing = tag.endsWith('/>') || VOID_HTML_TAGS.has(tagName)
    if (!selfClosing) {
      stack.push(tagName)
    }
    cursor = index + tag.length
  }

  const tail = value.slice(cursor)
  if (tail.includes('<') || tail.includes('>')) {
    return false
  }

  return stack.length === 0
}

export const stripHtmlTags = (value = '') => {
  return value.replace(/<[^>]*>?/g, '')
}
